import { TimeZoneEnum } from '@zaoblako/shared/common/enums/time.zone.enum';
import { SerdeTransformTypeEnum } from '@zaoblako/shared/modules/serde/enums/serde-transform-type.enum';
import type { SerdeContextInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context.interface';

import * as yup from 'yup';
import * as moment from 'moment-timezone';

const SERIALIZERS_MEMO = new Map<string, (context: SerdeContextInterface) => yup.Schema<Date>>();

/**
 * Provides custom dates schema which serialize date to special format and deserialize it from this format.
 *
 * @param format Date format (string with "Moment.JS" compatible tokens)
 *
 * @returns Serializer callback for SerDe schema
 */
export function dateFormatSchema(format: string): ((context: SerdeContextInterface) => yup.Schema<Date>) {
  if (SERIALIZERS_MEMO.has(format)) { // Use same serializer for same formats
    return SERIALIZERS_MEMO.get(format);
  }

  const result = (context: SerdeContextInterface): yup.Schema<Date> => {
    const timezone = context?.data?.tenant?.timezone || TimeZoneEnum.EUROPE_MOSCOW;
      if (context?.transform === SerdeTransformTypeEnum.SERIALIZE) {
        return yup
          .mixed()
          .transform(
            value => value
              ? moment
                .tz(value, timezone)
                .format(format)
              : null,
          ) as yup.Schema<any>;
      } else {
        return yup
          .mixed()
          .transform(
            value => value
              ? moment
                .tz(value, format, timezone)
                .toDate()
              : null,
          ) as yup.Schema<any>;
      }
  };
  SERIALIZERS_MEMO.set(format, result);

  return result;
}
